module.exports = __webpack_public_path__ + "static/media/shift_management.5132197c.png";